export default {
    SET_BALANCE_HISTORY(state, balanceHistory) {
        state.balanceHistory = balanceHistory.map(it => ({
            ...it,
            day: new Date(it.day)
        }))
    },

    SET_REFERRAL_HISTORY(state, referralsHistory) {
        state.referralsHistory = referralsHistory.map(it => ({
            ...it,
            day: new Date(it.day)
        }))
    },

    SET_BALANCE_HISTORY_TABLE(state, balanceHistoryTable) {
        state.balanceHistoryTable = balanceHistoryTable
    },

    SET_REFERRAL_HISTORY_TABLE(state, referralsHistoryTable) {
        state.referralsHistoryTable = referralsHistoryTable
    },

    SET_ORDERS_HISTORY(state, ordersHistory) {
        state.ordersHistory = ordersHistory.map(it => ({
            ...it,
            day: new Date(it.day)
        }))
    },

    SET_ORDERS_HISTORY_TABLE(state, ordersHistoryTable) {
        state.ordersHistoryTable = ordersHistoryTable
    },

    SET_LOAD(state, isLoaded) {
        state.isLoaded = isLoaded
    }
}
